module.exports ={
    language: 'Language',
}